import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertCircle, CheckCircle2, Timer, BellRing } from 'lucide-react';

const StaffingAlertsPanel = () => {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        const res = await axios.get('/api/staffing/alerts');
        setAlerts(res.data || []);
      } catch (err) {
        console.error('Error fetching staffing alerts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAlerts();
  }, []);

  if (loading) {
    return <div className="text-sm text-gray-400">Loading alerts...</div>;
  }

  if (alerts.length === 0) {
    return (
      <div className="text-green-400 font-medium text-sm bg-green-800/10 p-4 rounded-xl">
        ✅ All clear — no critical staffing alerts.
      </div>
    );
  }

  const iconMap = {
    'missing_clock_in': <Timer size={16} className="text-red-400" />,
    'pending_approval': <BellRing size={16} className="text-yellow-400" />,
    'overlap': <AlertCircle size={16} className="text-orange-400" />,
    'leave_today': <CheckCircle2 size={16} className="text-blue-400" />
  };

  return (
    <div className="bg-[#1e293b] border border-[#334155] rounded-2xl p-5 text-white shadow-xl">
      <h3 className="text-lg font-semibold mb-3">🚨 Staffing Alerts</h3>

      <ul className="space-y-2 text-sm">
        {alerts.map((alert, i) => (
          <li key={i} className="flex gap-2 items-start">
            <span>{iconMap[alert.type]}</span>
            <span>{alert.message}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StaffingAlertsPanel;
